import TelInput from 'vue-tel-input'
// import 'vue-tel-input/dist/vue-tel-input.css'

export default (Vue) => {
  Vue.component('tel-input', TelInput)
}
